import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { Redirect } from 'react-router-dom'

import ContactInformationForm from '../components/ContactInformationForm'
import validations from '../../../utils/validations'
import { updateProfile, fetchAllStations, clearProfileMessages } from '../actions/profileActions'

class ContactInformationContainer extends Component {

  componentWillUnmount() {
    this.props.clearProfileMessages()
  }

  profileOnSubmit = (values) => {
    this.props.updateProfile(values)
  }

  render() {
    const { location, success } = this.props
    if (success && location.state) {
      return (
        <Redirect
          to={{
            pathname: location.state.referer,
            state: { referer: location.pathname, success }
          }}
        />
      )
    }

    return (
      <ContactInformationForm
        form='contactInformationForm'
        validations={validations}
        initialValues={this.props.initialValues}
        onSubmit={this.profileOnSubmit}
        stationList={this.props.stationList}
        user={this.props.user}
        isSuccess={this.props.success}
        clearMessages={this.props.clearProfileMessages}
        secondaryPhone={this.props.secondaryPhone} />
    )
  }
}

const mapStateToProps = (state) => ({
  initialValues: state.currentUser,
  stationList: state.profileInfo.stationList.stations,
  user: state.currentUser,
  success: state.profileInfo.currentUserProfile.success,
  secondaryPhone: {
    number: formValueSelector('contactInformationForm')(state, 'secondaryPhoneNumber'),
    type: formValueSelector('contactInformationForm')(state, 'secondaryPhoneNumberType'),
    ext: formValueSelector('contactInformationForm')(state, 'secondaryPhoneNumberExtension')
  }
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ updateProfile, fetchAllStations, clearProfileMessages }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactInformationContainer)
